import {
  Phone,
  Mail,
  MapPin,
  MessageCircle,
  ArrowUpRight,
} from "lucide-react";

export default function ContactViewer() {
  return (
    <div style={styles.main}>
      <div style={styles.page}>

        {/* BACKGROUND GLOW */}

        <div style={styles.glowOne} />
        <div style={styles.glowTwo} />

        {/* SCROLL CONTAINER */}

        <main style={styles.scrollArea}>
          <div style={styles.container}>

            {/* HEADER */}

            <section style={styles.header}>

              <div style={styles.eyebrow}>
                <span style={styles.line} />

                ATHARVA LANDMARK

                <span
                  style={{
                    ...styles.line,
                    background:
                      "linear-gradient(90deg, #60a5fa, transparent)",
                  }}
                />
              </div>

              <h1 style={styles.title}>
                Let's Make Your
                <span style={styles.titleAccent}>
                  Dream Home
                </span>
              </h1>

              <p style={styles.description}>
                Atharva Landmark – Experience the Art of Luxurious Living. Where sophisticated design blends seamlessly with modern comfort, every space reflects elegance, and every detail is thoughtfully crafted. Discover spacious residences, timeless architecture, and an elevated lifestyle designed for those who aspire to live exceptionally.
              </p>

            </section>

            {/* CONTACT CARD */}

            <section style={styles.contactWrapper}>

              <div style={styles.contactHeader}>
                <div>
                  <span style={styles.smallLabel}>
                    CONNECT WITH US
                  </span>

                  <h2 style={styles.contactTitle}>
                    Contact Information
                  </h2>
                </div>
              </div>

              {/* CONTACT GRID */}

              <div style={styles.grid}>

                {/* PHONE */}

                <a
                  href="tel:+919213637726"
                  style={styles.card}
                >
                  <div style={styles.iconBox}>
                    <Phone size={25} />
                  </div>

                  <div style={styles.label}>
                    Phone
                  </div>

                  <div style={styles.value}>
                    92136 37726
                  </div>


                  <div style={styles.actionText}>
                    Call us
                    <ArrowUpRight size={15} />
                  </div>
                </a>

                {/* EMAIL */}

                <a
                  href="mailto:atharvalandmark@gmail.com"
                  style={styles.card}
                >
                  <div style={styles.iconBox}>
                    <Mail size={25} />
                  </div>

                  <div style={styles.label}>
                    Email
                  </div>

                  <div style={styles.emailValue}>
                    atharvalandmark@gmail.com
                  </div>

                  <div style={styles.actionText}>
                    Send email
                    <ArrowUpRight size={15} />
                  </div>
                </a>

                {/* LOCATION */}

                <a
                  href="https://maps.app.goo.gl/6vrQPVSteJcDTXKC7"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    ...styles.card,
                    ...styles.locationCard,
                  }}
                >
                  <div style={styles.iconBox}>
                    <MapPin size={25} />
                  </div>

                  <div style={styles.label}>
                    Location
                  </div>

                  <div style={styles.locationText}>
                    <strong>
                      Atharva Landmark
                    </strong>

                    <br />

                    Behind funblast
                    <br />

                    SP Ring Road, Bilasiya (New Nikol)
                    <br />

                    Ahmedabad – 382470
                  </div>

                  <div style={styles.actionText}>
                    View on Maps
                    <ArrowUpRight size={15} />
                  </div>
                </a>

              </div>

              {/* CTA */}

              <div className="contact-cta" style={styles.ctaSection}>

                <div className="cta-text" style={styles.ctaText}>
                  <span style={styles.ctaSmall}>
                    HAVE QUESTIONS?
                  </span>

                  <h3 style={styles.ctaTitle}>
                    Let's talk about your
                    <span> dream home.</span>
                  </h3>
                </div>

                <div className="cta-buttons" style={styles.buttons}>

                  <a
                    href="tel:+919213637726"
                    style={styles.callButton}
                  >
                    <Phone size={19} />
                    <span>Call Now</span>
                  </a>

                  <a
                    href="https://wa.me/919213637726"
                    target="_blank"
                    rel="noreferrer"
                    style={styles.whatsappButton}
                  >
                    <MessageCircle size={19} />
                    <span>WhatsApp</span>
                  </a>

                </div>

              </div>

            </section>

            {/* FOOTER */}

            <div style={styles.footer}>
              <span style={styles.footerDot} />

              Experience the Art of Luxurious Living

              <span
                style={{
                  ...styles.footerDot,
                }}
              />
            </div>

            {/* EXTRA BOTTOM SPACE */}

            <div style={{ height: 30 }} />

          </div>
        </main>
      </div>
    </div>
  );
}

const isMobile = window.innerWidth <= 768;

const styles = {

  main: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    height: "100dvh",
    overflowY: "auto",
    overflowX: "hidden",
    WebkitOverflowScrolling: "touch",
    zIndex: 1,
  },

  page: {
    position: "relative",

    width: "100%",
    height: "100%",

    overflow: "hidden",

    background:
      "radial-gradient(circle at 50% -20%, #173f70 0%, #0a1c31 32%, #030812 75%, #02050a 100%)",

    color: "#fff",

    fontFamily:
      "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif",
  },

  scrollArea: {
    position: "relative",

    zIndex: 2,

    width: "100%",
    height: "100%",

    overflowY: "auto",
    overflowX: "hidden",

    WebkitOverflowScrolling: "touch",

    boxSizing: "border-box",

    scrollbarWidth: "thin",

    scrollbarColor:
      "#112d61 transparent",
  },

  glowOne: {
    position: "absolute",

    width: 450,
    height: 450,

    borderRadius: "50%",

    background:
      "radial-gradient(circle, rgba(37,99,235,0.2), transparent 70%)",

    filter: "blur(45px)",

    top: -220,
    left: -180,

    pointerEvents: "none",

    zIndex: 0,
  },

  glowTwo: {
    position: "absolute",

    width: 400,
    height: 400,

    borderRadius: "50%",

    background:
      "radial-gradient(circle, rgba(14,165,233,0.14), transparent 70%)",

    filter: "blur(45px)",

    bottom: -200,
    right: -160,

    pointerEvents: "none",

    zIndex: 0,
  },

  container: {
    width: "100%",
    maxWidth: 1180,

    margin: "0 auto",

    padding: isMobile
      ? "120px 20px 40px"
      : "80px 20px 40px",

    boxSizing: "border-box",
  },

  header: {
    textAlign: "center",

    maxWidth: 850,

    margin:
      "0 auto 45px",
  },

  eyebrow: {
    display: "flex",

    alignItems: "center",
    justifyContent: "center",

    gap: 12,

    color: "#60a5fa",

    fontSize: 11,

    fontWeight: 700,

    letterSpacing: "3px",

    marginBottom: 18,
  },

  line: {
    width: 30,
    height: 1,

    background:
      "linear-gradient(90deg, transparent, #60a5fa)",
  },

  title: {
    margin: 0,

    fontSize:
      "clamp(38px, 7vw, 64px)",

    lineHeight: 1.05,

    fontWeight: 300,

    letterSpacing: "-2px",
  },

  titleAccent: {
    display: "block",

    marginTop: 7,

    color: "#60a5fa",

    fontWeight: 500,
  },

  description: {
    margin:
      "22px auto 0",

    maxWidth: 760,

    color:
      "rgba(255,255,255,0.65)",

    fontSize: 15,

    lineHeight: 1.75,
  },

  contactWrapper: {
    padding: 25,

    borderRadius: 28,

    background:
      "linear-gradient(145deg, rgba(30,64,175,0.15), rgba(15,23,42,0.65))",

    border:
      "1px solid rgba(96,165,250,0.16)",

    backdropFilter: "blur(20px)",

    WebkitBackdropFilter:
      "blur(20px)",

    boxShadow:
      "0 25px 70px rgba(0,0,0,0.35)",

    boxSizing: "border-box",
  },

  contactHeader: {
    marginBottom: 25,
  },

  smallLabel: {
    color: "#60a5fa",

    fontSize: 10,

    fontWeight: 700,

    letterSpacing: "2px",
  },

  contactTitle: {
    margin:
      "7px 0 0",

    fontSize:
      "clamp(24px, 4vw, 32px)",

    fontWeight: 600,
  },

  grid: {
    display: "grid",

    gridTemplateColumns:
      "repeat(auto-fit, minmax(250px, 1fr))",

    gap: 16,
  },

  card: {
    minHeight: 235,

    display: "flex",

    flexDirection: "column",

    alignItems: "center",

    justifyContent: "center",

    padding: 24,

    textAlign: "center",

    textDecoration: "none",

    color: "#fff",

    borderRadius: 20,

    background:
      "linear-gradient(145deg, rgba(255,255,255,0.07), rgba(255,255,255,0.025))",

    border:
      "1px solid rgba(96,165,250,0.14)",

    boxShadow:
      "0 12px 35px rgba(0,0,0,0.25)",

    boxSizing: "border-box",

    transition:
      "transform 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease",
  },

  locationCard: {
    minHeight: 265,
  },

  iconBox: {
    width: 58,
    height: 58,

    display: "flex",

    alignItems: "center",
    justifyContent: "center",

    borderRadius: 16,

    color: "#60a5fa",

    background:
      "linear-gradient(135deg, rgba(37,99,235,0.22), rgba(14,165,233,0.06))",

    border:
      "1px solid rgba(96,165,250,0.22)",

    marginBottom: 15,

    boxShadow:
      "0 8px 25px rgba(37,99,235,0.12)",
  },

  label: {
    fontSize: 16,

    fontWeight: 600,

    marginBottom: 8,
  },

  value: {
    color: "#93c5fd",

    fontSize: 16,

    lineHeight: 1.5,
  },

  emailValue: {
    color: "#93c5fd",

    fontSize: 14,

    lineHeight: 1.5,

    wordBreak: "break-word",

    maxWidth: "100%",
  },

  locationText: {
    color:
      "rgba(255,255,255,0.65)",

    fontSize: 13,

    lineHeight: 1.65,

    maxWidth: 320,
  },

  actionText: {
    display: "flex",

    alignItems: "center",

    gap: 5,

    marginTop: 13,

    color: "#60a5fa",

    fontSize: 11,

    fontWeight: 600,
  },

  ctaSection: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 25,
    marginTop: 25,
    padding: 22,
    borderRadius: 20,

    background:
      "linear-gradient(135deg, rgba(37,99,235,0.18), rgba(14,165,233,0.05))",

    border:
      "1px solid rgba(96,165,250,0.14)",

    boxSizing: "border-box",
  },

  ctaText: {
    flex: 1,
    minWidth: 200,
  },

  ctaSmall: {
    color: "#60a5fa",
    fontSize: 9,
    fontWeight: 700,
    letterSpacing: "2px",
  },

  ctaTitle: {
    margin: "6px 0 0",
    fontSize: "clamp(19px, 3vw, 26px)",
    lineHeight: 1.3,
    fontWeight: 500,
  },

  buttons: {
    display: "flex",
    gap: 10,
    flexWrap: "wrap",
    justifyContent: "center",
    flexShrink: 0,
  },

  callButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,

    padding: "13px 20px",

    borderRadius: 13,

    background:
      "linear-gradient(135deg, #2563eb, #1d4ed8)",

    color: "#fff",
    textDecoration: "none",

    fontSize: 14,
    fontWeight: 600,
    whiteSpace: "nowrap",

    boxShadow:
      "0 8px 22px rgba(37,99,235,0.25)",

    transition: "all 0.25s ease",
  },

  whatsappButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,

    padding: "13px 20px",

    borderRadius: 13,

    background:
      "rgba(255,255,255,0.06)",

    border:
      "1px solid rgba(96,165,250,0.2)",

    color: "#93c5fd",

    textDecoration: "none",

    fontSize: 14,
    fontWeight: 600,
    whiteSpace: "nowrap",

    transition: "all 0.25s ease",
  },

  footer: {
    display: "flex",

    alignItems: "center",

    justifyContent: "center",

    gap: 10,

    marginTop: 30,

    color:
      "rgba(255,255,255,0.35)",

    fontSize: 11,

    textAlign: "center",
  },

  footerDot: {
    width: 5,
    height: 5,

    flexShrink: 0,

    borderRadius: "50%",

    background: "#60a5fa",

    boxShadow:
      "0 0 8px rgba(96,165,250,0.7)",
  },
};
